import { motion } from "framer-motion";

const projects = [
  {
    label: "Project 01",
    description: "Retail-facing visual system",
    image: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/kuxi4qya_GLOW%20AND%20GOOO%202.png",
  },
  {
    label: "Project 02",
    description: "Brand identity refresh",
    image: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/y5nlpkjm_Shakems.jpg",
  },
  {
    label: "Project 03",
    description: "Packaging range planning",
    image: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/72i7x5vr_KITTY%20CORN%20PRODUCT.jpg",
  },
  {
    label: "Project 04",
    description: "Retail strategy & positioning",
    image: "https://images.unsplash.com/photo-1769107805412-90d9191d53e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjByZXRhaWwlMjBzdG9yZSUyMGludGVyaW9yJTIwbWluaW1hbGlzdCUyMG5ldXRyYWx8ZW58MHx8fHwxNzcyODQ0MzAzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    label: "Project 05",
    description: "Product design system",
    image: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/8hq7d4qq_Zombites%20Toxic%20Taba.png",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.1, ease: [0.25, 0.46, 0.45, 0.94] },
  }),
};

export const SelectedWork = () => {
  return (
    <section data-testid="selected-work-section" className="py-24 md:py-36 bg-off-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          custom={0}
          className="mb-12 md:mb-16"
        >
          <span className="font-body text-xs uppercase tracking-[0.2em] text-charcoal/50 block mb-4">
            Portfolio
          </span>
          <h2
            data-testid="selected-work-heading"
            className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-[-0.02em] text-deep-black font-light"
          >
            Selected work
          </h2>
        </motion.div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6" style={{ gridTemplateRows: 'auto auto auto' }}>
          {/* Row 1-2: Large left + two stacked right */}
          <motion.div
            data-testid="work-item-0"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={fadeUp}
            custom={0}
            className="lg:col-span-2 lg:row-span-2 group cursor-pointer"
          >
            <div className="relative img-zoom rounded-2xl overflow-hidden h-full min-h-[300px] lg:min-h-0">
              <img
                src={projects[0].image}
                alt={projects[0].description}
                className="w-full h-full object-cover absolute inset-0"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-deep-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="font-body text-xs uppercase tracking-[0.15em] text-white/60 block mb-1">{projects[0].label}</span>
                <p className="font-heading text-base text-white font-medium tracking-tight">{projects[0].description}</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            data-testid="work-item-1"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={fadeUp}
            custom={1}
            className="group cursor-pointer"
          >
            <div className="relative img-zoom rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src={projects[1].image}
                alt={projects[1].description}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-deep-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="font-body text-xs uppercase tracking-[0.15em] text-white/60 block mb-1">{projects[1].label}</span>
                <p className="font-heading text-base text-white font-medium tracking-tight">{projects[1].description}</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            data-testid="work-item-2"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={fadeUp}
            custom={2}
            className="group cursor-pointer"
          >
            <div className="relative img-zoom rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src={projects[2].image}
                alt={projects[2].description}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-deep-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="font-body text-xs uppercase tracking-[0.15em] text-white/60 block mb-1">{projects[2].label}</span>
                <p className="font-heading text-base text-white font-medium tracking-tight">{projects[2].description}</p>
              </div>
            </div>
          </motion.div>

          {/* Row 3: Wide left + square right */}
          <motion.div
            data-testid="work-item-3"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={fadeUp}
            custom={3}
            className="lg:col-span-2 group cursor-pointer"
          >
            <div className="relative rounded-2xl overflow-hidden aspect-[2/1]">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover"
              >
                <source src="/project-video.webm" type="video/webm" />
                <source src="/project-video-h264.mp4" type="video/mp4" />
              </video>
              <div className="absolute inset-0 bg-gradient-to-t from-deep-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="font-body text-xs uppercase tracking-[0.15em] text-white/60 block mb-1">{projects[3].label}</span>
                <p className="font-heading text-base text-white font-medium tracking-tight">{projects[3].description}</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            data-testid="work-item-4"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={fadeUp}
            custom={4}
            className="group cursor-pointer"
          >
            <div className="relative img-zoom rounded-2xl overflow-hidden h-full">
              <img
                src={projects[4].image}
                alt={projects[4].description}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-deep-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="font-body text-xs uppercase tracking-[0.15em] text-white/60 block mb-1">{projects[4].label}</span>
                <p className="font-heading text-base text-white font-medium tracking-tight">{projects[4].description}</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
